import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useAuth } from "../auth/AuthContext";
import usePageTitle from "../utils/usePageTitle";

// Pagină publică de autentificare — design preluat din template (SignInLayer).
export default function LoginPage() {
  usePageTitle("Autentificare");
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [veziParola, setVeziParola] = useState(false);
  const [eroare, setEroare] = useState("");
  const [salveaza, setSalveaza] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEroare("");
    setSalveaza(true);
    try {
      await login(email, password);
      navigate(location.state?.from || "/dashboard", { replace: true });
    } catch (err) {
      setEroare(err.message);
      setSalveaza(false);
    }
  };

  return (
    <section className="auth bg-base d-flex flex-wrap">
      {/* Panoul stâng cu ilustrația template-ului */}
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src="assets/images/auth/auth-img.png" alt="" />
        </div>
      </div>

      {/* Formularul */}
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <img src="assets/images/logo.png" alt="iCode CRM" className="light-logo mb-40 max-w-290-px" />
            <h4 className="mb-12">Autentificare în CRM iCode</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Bine ai revenit! Introdu datele contului tău.
            </p>
          </div>

          {eroare && (
            <div className="alert alert-danger d-flex align-items-center gap-2" role="alert">
              <Icon icon="solar:danger-triangle-outline" className="icon text-xl" />
              {eroare}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={veziParola ? "text" : "password"}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  placeholder="Parolă"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <span
                className={`toggle-password ${veziParola ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                onClick={() => setVeziParola(!veziParola)}
                role="button"
                aria-label={veziParola ? "Ascunde parola" : "Arată parola"}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              disabled={salveaza}
            >
              {salveaza ? (
                <span className="spinner-border spinner-border-sm me-8" role="status" aria-hidden="true" />
              ) : (
                <Icon icon="solar:login-2-outline" className="icon text-xl me-8" />
              )}
              Autentificare
            </button>
            <p className="mt-32 text-center text-secondary-light text-sm mb-0">
              Acces restricționat angajaților iCode.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}
